<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
    card: Object,
    darkmode: Boolean
});

const { t } = useI18n();
const emit = defineEmits(['edit','archive','delete','open']);
</script>

<template>
    <div class="card-row-premium" @click="$emit('open', card.id)">

        <div class="card-row-left">
            <div class="card-row-icon">
                <img :src="card.icon" alt="">
            </div>

            <div class="card-row-info">
                <strong>{{ card.name }}</strong>
                <span v-if="card.archived == 'Yes'">Arquivado</span>
            </div>
        </div>

        <div class="card-row-actions" @click.stop>

            <button v-if="card.archived == 'No'"
                @click="$emit('edit', card)"
                data-bs-toggle="modal"
                data-bs-target="#addCard"
                class="card-row-btn"
            >
                <i class="fal fa-pencil"></i>
            </button>

            <button v-if="card.archived == 'No'"
                @click="$emit('archive', card, 'Yes')"
                class="card-row-btn"
            >
                <i class="fal fa-inbox-in"></i>
            </button>

            <button v-if="card.archived == 'Yes'"
                @click="$emit('archive', card, 'No')"
                class="card-row-btn"
            >
                <i class="fal fa-inbox-out"></i>
            </button>

            <button v-if="card.archived == 'Yes'"
                @click="$emit('delete', card)"
                class="card-row-btn danger"
            >
                <i class="fal fa-trash"></i>
            </button>

        </div>

    </div>
</template>

<style>
.card-row-premium{
    display:flex;
    align-items:center;
    justify-content:space-between;
    padding:14px 16px;
    border-radius:18px;
    transition:.2s;
    cursor:pointer;
}

.card-row-premium:hover{
    background:rgba(0,0,0,0.03);
}

.card-row-left{
    display:flex;
    align-items:center;
    gap:12px;
}

.card-row-icon{
    width:48px;
    height:48px;
    border-radius:16px;
    background:#fff;
    display:flex;
    align-items:center;
    justify-content:center;
    box-shadow:0 6px 16px rgba(0,0,0,0.08);
}

.card-row-icon img{
    width:70%;
}

.card-row-info strong{
    display:block;
    color:#213E60;
    font-weight:700;
}

.card-row-info span{
    font-size:12px;
    color:#8a9bb5;
}

.card-row-actions{
    display:flex;
    gap:8px;
}

.card-row-btn{
    width:36px;
    height:36px;
    border-radius:10px;
    border:none;
    background:#f1f5f9;
    display:flex;
    align-items:center;
    justify-content:center;
    transition:.2s;
}

.card-row-btn:hover{
    background:#e2e8f0;
    transform:translateY(-1px);
}

.card-row-btn.danger{
    background:#fee2e2;
    color:#ef4444;
}
</style>
